import React from "react";
import Sidebar from "../pages/admin/Sidebar/Sidebar"
import Header from "../pages/admin/Header/Header";
import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  return (
    <div className="al-shell">
      <Sidebar />
      <div className="al-body">
        <Header />
        <main className="al-main">
          <div className="al-inner">{children}</div>
        </main>
      </div>
    </div>
  );
}